import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { parseFullName, parseSum } from 'utils/helpers';
import { TableCell, TableRow } from '@mui/material';

const RetrocessionRow = ({ retrocession, navs, fundDecimals }) => {
    const {
        subscription: { user, ...subscription },
        distributorCompany,
        shareValue,
        amount,
        periodStartDate,
        periodEndDate,
    } = retrocession;

    return (
        <TableRow>
            <TableCell>
                {user?.investorCompany ? user.investorCompany?.corporateName : parseFullName(user)}
            </TableCell>
            <TableCell>{distributorCompany?.corporateName}</TableCell>
            <TableCell>{subscription?.investmentCharacteristics?.shareSubcategory?.name}</TableCell>
            <TableCell>
                {parseFloat(
                    subscription?.investmentCharacteristics?.investingSum /
                        subscription?.investmentCharacteristics?.shareValue
                ).toFixed(fundDecimals || 3)}
            </TableCell>
            <TableCell>{shareValue}</TableCell>
            <TableCell>{moment(periodStartDate).format('L')}</TableCell>
            <TableCell>{moment(periodEndDate).format('L')}</TableCell>
            <TableCell>{parseSum(amount)}</TableCell>
        </TableRow>
    );
};

RetrocessionRow.propTypes = {
    retrocession: PropTypes.shape({
        id: PropTypes.number.isRequired,
        amount: PropTypes.number,
        shareValue: PropTypes.number,
        user: PropTypes.object,
        subscription: PropTypes.object,
        distributorCompany: PropTypes.object,
        periodStartDate: PropTypes.string,
        periodEndDate: PropTypes.string,
    }),
    navs: PropTypes.array,
    fundDecimals: PropTypes.number,
};

export default RetrocessionRow;
